import { Divider, Row } from "antd";
import '../../../../styles/ChartStyles.css';

export function ChartDivider({ title, stitle }) {
  return (
    <>
      <Row
        align="middle"
        justify="space-between"
        className="chart-divider-row"
        gutter={5}
      >
        <Divider
          className="TituloRegularGA chart-divider  "
          orientation="left"
          orientationMargin={100.5}
          
        >
          {title}
          <br />
          <span className="TituloBoldGA">{stitle}</span>
        </Divider>
      </Row>
    </>
  );
}
export function SubtitleDivider({ subtitle }) {
  return (
    <>
      <div
        className="SubtituloCharts chart-subtitle"
      >
        {subtitle}
      </div>
      <br />
    </>
  );
}
